import React from 'react';
// REDUX
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
//COMPONENTS
import MenuListadoDeReportes from './MenuListadoReportes'

function ListadoDeReportes(props) {
    // props.MODULO_FALLECIDOS_SET_TAB()
    return (
        <div style={{backgroundColor:'#D4D8E1'}}>
            <MenuListadoDeReportes />
        </div>
    );
}
export default connect(mapStateToProps, mapDispatchToProps)(ListadoDeReportes);